import { Directive } from '@angular/core';
import { ToggleableDirective } from '../common/toggleable.directive';

/**
 * Fallback/default for when no other media query switch case matches.
 */
@Directive({
    selector: '[oscMediaQuerySwitchDefault]',
    standalone: false
})
export class MediaQuerySwitchDefaultDirective extends ToggleableDirective {}
